// SearchInput.js
import React from 'react'
import searchIcon from './assets/searchIcon.svg'
const SearchInput = ({ searchTerm, onSearchChange, onSearchSubmit }) => {
  return (
    <div style={{ position: 'relative', width: '100%', maxWidth: '400px' }}>
      <input
        type="text"
        value={searchTerm}
        onChange={onSearchChange}
        placeholder={localStorage.getItem('languageId') === '5' ? 'Search' : 'Поиск'}
        style={{
          width: '100%',
          padding: '12px 50px 12px 15px',
          border: '1px solid #ccc',
          outline: 'none',
          fontSize: '16px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }}
      />
        <img
          src={searchIcon}
          alt=""
          width={37}
          onClick={onSearchSubmit}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            border: 'none',
            color: 'white',
            padding: '6px 8px',
            cursor: 'pointer',
            fontSize: '36px',
          }}
        />
    </div>
  )
}

export default SearchInput



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/GamesPageNewLayout/Input.jsx